import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { IHowItWorksStepIdentifier, IHowItWorksStepItem } from './ILoyaltyHowItWorks';
import { classes } from '~utils/Classes';

export const TEST_ID_HOW_IT_WORKS_ITEM = 'how-it-works-step-item';
const howItWorksItemWrapperClass = classes('how-it-works-step-item');
const howItWorksStepIdentifierClass = classes('how-it-works-step-identifier');
const howItWorksStepNameClass = classes('how-it-works-step-name');
const howItWorksStepNumberClass = classes('how-it-works-step-number');
const howItWorksStepDescriptionClass = classes('how-it-works-step-desc');
const howItWorksStepDescriptionParagraphClass = classes('how-it-works-step-desc-paragraph');

// prettier-ignore
const HowItWorksItemWrapper = styled.div<{ index: number }>`
    grid-area: StepItem${({ index }) => index};
`;

const HowItWorksStepImage = styled.img`
    width: 100%;
    height: 100%;
`;

const HowItWorksStepIdentifier = observer((props: IHowItWorksStepIdentifier) => {
    const { exitingImage, stepNumber, stepImage } = props;

    return exitingImage ? (
        <HowItWorksStepImage {...stepImage} />
    ) : (
        <p className={howItWorksStepNumberClass}>{stepNumber}</p>
    );
});

const HowItWorksStepItem = observer(function HowItWorksItem(props: IHowItWorksStepItem) {
    const { stepNumber, stepImage, stepName, stepDescription, itemNumber } = props.data;
    const exitingImage = !!stepImage?.src?.length;

    return (
        <HowItWorksItemWrapper
            index={itemNumber}
            data-test-id={TEST_ID_HOW_IT_WORKS_ITEM}
            className={howItWorksItemWrapperClass}
        >
            <div className={howItWorksStepIdentifierClass}>
                <HowItWorksStepIdentifier exitingImage={exitingImage} stepNumber={stepNumber} />
            </div>
            <div className={howItWorksStepNameClass}>
                <p className={howItWorksStepDescriptionParagraphClass}>{stepName}</p>
            </div>
            <div className={howItWorksStepDescriptionClass}>
                <p className={howItWorksStepDescriptionParagraphClass}>{stepDescription}</p>
            </div>
        </HowItWorksItemWrapper>
    );
});

export default HowItWorksStepItem as React.FC<IHowItWorksStepItem>;
export { HowItWorksStepItem };
